import apiClient from './apiClient';

const baseUrl = process.env.REACT_APP_BASE_URL;

class AdminPaymentService {
  // Get payment statistics
  async getPaymentStats() {
    try {
      const response = await apiClient.get(`${baseUrl}/admin/payments/stats`);
      return response.data;
    } catch (error) {
      console.error('Error fetching payment stats:', error);
      throw error;
    }
  }

  // Get all payments with pagination and filters
  async getAllPayments(params = {}) {
    try {
      const response = await apiClient.get(`${baseUrl}/admin/payments/all`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching payments:', error);
      throw error;
    }
  }

  // Get payment by ID
  async getPaymentById(paymentId) {
    try {
      const response = await apiClient.get(`${baseUrl}/admin/payments/${paymentId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching payment by ID:', error);
      throw error;
    }
  }

  // Search payments
  async searchPayments(query, page = 0, size = 10) {
    try {
      const response = await apiClient.get(`${baseUrl}/admin/payments`, {
        params: {
          search: query,
          page,
          size
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error searching payments:', error);
      throw error;
    }
  }

  // Refund payment
  async refundPayment(paymentId, refundData) {
    try {
 
      const response = await apiClient.post(`${baseUrl}/razorpay/payments/${paymentId}/refund`, refundData);
      return response.data;
    } catch (error) {
      console.error('Error refunding payment:', error);
      throw error;
    }
  }

  // Get refund details by refund ID
  async getRefundDetails(refundId) {
    try {
      const response = await apiClient.get(`${baseUrl}/razorpay/refunds/${refundId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching refund details:', error);
      throw error;
    }
  }

  // Get all refunds
  async getAllRefunds(count = 10, skip = 0) {
    try {
      const response = await apiClient.get(`${baseUrl}/razorpay/refunds`, {
        params: { count, skip }
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching refunds:', error);
      throw error;
    }
  }
}

export default new AdminPaymentService();
